import { examinationMobileDevice } from "../../../utils/consts";

export const HookResponsive = () => {

  return !examinationMobileDevice.test(navigator.userAgent);
};
